import Tools from '../../assets/img/tools.png';


export const SectionTitleCard  = () => {
  return (
    <div className="flex items-center gap-4 rounded-lg">
      <img src={Tools} alt="Tools" style={{height: '56px', width: '56px'}}/>
      <div>
        <h5 className="text-gray-900 mb-2" style={{ fontFamily: 'Onest', fontWeight: 500, fontSize: '26px', lineHeight: '100%' }}>
          Toate autoservice-urile
        </h5>
        <p style={{ fontFamily: 'Onest', fontWeight: 400, fontSize: '15px', lineHeight: '100%' }}>
          Găsește autoservice-ul potrivit pentru mașina ta.
        </p>
      </div>
    </div>
  );

}